import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Default ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Show billing template")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Delete")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_th = _resolveComponent("q-th")!
  const _component_q_tr = _resolveComponent("q-tr")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_table = _resolveComponent("q-table")!

  return (_openBlock(), _createBlock(_component_q_table, {
    columns: _ctx.billingTemplatesColumns,
    rows: _ctx.billingTemplatesList,
    "visible-columns": _ctx.visibleColumns,
    "row-key": "billingTemplateId",
    flat: ""
  }, {
    header: _withCtx((props) => [
      _createVNode(_component_q_tr, { props: props }, {
        default: _withCtx(() => [
          _createVNode(_component_q_th, { "auto-width": "" }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.cols, (col) => {
            return (_openBlock(), _createBlock(_component_q_th, {
              key: col.name,
              props: props
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(col.label), 1)
              ]),
              _: 2
            }, 1032, ["props"]))
          }), 128))
        ]),
        _: 2
      }, 1032, ["props"])
    ]),
    "body-cell-default": _withCtx((props) => [
      _createVNode(_component_q_td, { props: props }, {
        default: _withCtx(() => [
          _createVNode(_component_q_checkbox, {
            modelValue: props.row.isDefault,
            "onUpdate:modelValue": [($event: any) => ((props.row.isDefault) = $event), value => _ctx.onCheckboxChange(props.row, value)]
          }, null, 8, ["modelValue", "onUpdate:modelValue"])
        ]),
        _: 2
      }, 1032, ["props"])
    ]),
    "body-cell-actions": _withCtx((props) => [
      _createVNode(_component_q_td, { props: props }, {
        default: _withCtx(() => [
          _createVNode(_component_q_btn, {
            dense: "",
            round: "",
            flat: "",
            color: "grey",
            onClick: ($event: any) => (_ctx.onShowBillingTemplate(null, props.row)),
            icon: "pageview"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_tooltip, null, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              })
            ]),
            _: 2
          }, 1032, ["onClick"]),
          _createVNode(_component_q_btn, {
            dense: "",
            round: "",
            flat: "",
            color: "grey",
            onClick: ($event: any) => (_ctx.onDeleteBillingTemplate(props.row)),
            icon: "delete"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_tooltip, null, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              })
            ]),
            _: 2
          }, 1032, ["onClick"])
        ]),
        _: 2
      }, 1032, ["props"])
    ]),
    _: 1
  }, 8, ["columns", "rows", "visible-columns"]))
}